<template>
    <Form :colon="false" :ref="e => (refs.form = e)" layout="horizontal">
        <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fields" :skeleton="isLoading"></TemplateBuilder>
    </Form>
</template>

<script>
import { defineAsyncComponent, defineComponent, reactive, watch } from "vue";
import { /*Card,*/ Form, /*Input*/ } from "ant-design-vue";
import { state as stateApp } from "../../../../../../app.logic";
import { initForm } from "./vessel.logic";

export default defineComponent({
    components: {
        Form,
        TemplateBuilder: defineAsyncComponent(() => import("../../../../../../components/input/template-builder/TemplateBuilder"))
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        viewOnly: { default: false },
        dataProp: {},
        isLoading: {},
        itemsKey: { default: "refVesselRequest"}
    },
    setup(props) {
        const data = reactive({ ...props.dataProp });
        const refs = reactive({ form: null });
        initForm({ props, data, refs });
        watch(
            () => (data.useForm?.modelRef?.licenseCode),
            () => initForm({ props, data, refs }),
            { flush: "post" }
        );
        return {
            props,
            data,
            refs
        };
    }
});
</script>